"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Noop function (do nothing)
 */
var noop = exports.noop = function noop() {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-howler/lib/utils.js
// module id = 203
// module chunks = 0